import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle, Sparkles } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { track } from "../lib/analytics";

const PremiumReturn = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [state, setState] = useState("verifying"); // verifying | success | failed

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const reference = params.get("ref") || params.get("session_id");
    if (!reference) {
      setState("failed");
      return;
    }
    let attempts = 0;
    let timer;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${reference}`);
        if (data.payment_status === "paid") {
          track("purchase", { currency: (data.currency || "USD").toUpperCase(), value: data.amount || 0 });
          await checkAuth();
          setState("success");
          return;
        }
        if (["failed", "expired"].includes(data.payment_status)) {
          setState("failed");
          return;
        }
      } catch (e) {
        if (attempts >= 6) { setState("failed"); return; }
      }
      if (attempts >= 10) { setState("failed"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen bg-kora-sand flex items-center justify-center px-6" data-testid="premium-return-page">
      <div className="text-center max-w-sm">
        {state === "verifying" && (
          <>
            <Loader2 size={44} className="text-kora-terracotta animate-spin mx-auto mb-4" />
            <h1 className="font-display font-black text-2xl text-kora-ink">Vérification du paiement…</h1>
            <p className="text-kora-ink/60 mt-2 text-sm">Merci de patienter un instant.</p>
          </>
        )}
        {state === "success" && (
          <>
            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-kora-terracotta to-kora-ochre flex items-center justify-center mx-auto mb-5">
              <Sparkles size={36} className="text-white" />
            </div>
            <h1 className="font-display font-black text-3xl text-kora-ink">Bienvenue Premium ✨</h1>
            <p className="text-kora-ink/60 mt-2">Votre paiement a été confirmé. Profitez de toutes les fonctionnalités !</p>
            <button data-testid="return-continue-btn" onClick={() => navigate("/decouvrir")} className="mt-6 bg-kora-terracotta text-white rounded-full px-8 py-4 font-bold">Continuer</button>
          </>
        )}
        {state === "failed" && (
          <>
            <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-5">
              <XCircle size={36} className="text-red-500" />
            </div>
            <h1 className="font-display font-black text-2xl text-kora-ink">Paiement non confirmé</h1>
            <p className="text-kora-ink/60 mt-2">Le paiement n'a pas abouti ou a été annulé. Vous pouvez réessayer.</p>
            <button data-testid="return-retry-btn" onClick={() => navigate("/premium")} className="mt-6 bg-kora-terracotta text-white rounded-full px-8 py-4 font-bold">Réessayer</button>
          </>
        )}
      </div>
    </div>
  );
};

export default PremiumReturn;
